/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Category_1Inputs */

const en_category_1 = /** @type {(inputs: Category_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category`)
};

const es_category_1 = /** @type {(inputs: Category_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoría`)
};

const fr_category_1 = /** @type {(inputs: Category_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catégorie`)
};

const de_category_1 = /** @type {(inputs: Category_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategorie`)
};

const ja_category_1 = /** @type {(inputs: Category_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カテゴリ`)
};

const zh_category_1 = /** @type {(inputs: Category_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`类别`)
};

const ar_category_1 = /** @type {(inputs: Category_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفئة`)
};

const id_category_1 = /** @type {(inputs: Category_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategori`)
};

const it_category_1 = /** @type {(inputs: Category_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoria`)
};

const ru_category_1 = /** @type {(inputs: Category_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Категория`)
};

const pt_category_1 = /** @type {(inputs: Category_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoria`)
};

const ko_category_1 = /** @type {(inputs: Category_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`카테고리`)
};

/**
* | output |
* | --- |
* | "Category" |
*
* @param {Category_1Inputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const category_1 = /** @type {((inputs?: Category_1Inputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Category_1Inputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_category_1(inputs)
	if (locale === "es") return es_category_1(inputs)
	if (locale === "fr") return fr_category_1(inputs)
	if (locale === "de") return de_category_1(inputs)
	if (locale === "ja") return ja_category_1(inputs)
	if (locale === "zh") return zh_category_1(inputs)
	if (locale === "ar") return ar_category_1(inputs)
	if (locale === "id") return id_category_1(inputs)
	if (locale === "it") return it_category_1(inputs)
	if (locale === "ru") return ru_category_1(inputs)
	if (locale === "pt") return pt_category_1(inputs)
	return ko_category_1(inputs)
});